import * as React from 'react';
import './userInfoInputItem.module.scss';

type Props = {
  name: string;
  value: string | number;
  type?: string;
  error?: string;
  placeholder: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (newValue: string) => any;
};

export const UserInfoInputItem = ({ name, value, type = 'text', error, placeholder, onChange }: Props) => {
  const handleChange = (e) => onChange(e.target.value);
  return (
    <div styleName="input-row">
      <input
        styleName="input"
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
      />
      {error && <div styleName="error">{error}</div>}
    </div>
  );
};
